var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRListOrdered(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn-secondary",
    serifid: "btn secondary"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ph-desktop"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ph-note-pencil"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ph-pen-nib"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-5",
    serifid: "Rating 5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4-5",
    serifid: "Rating 4,5"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4",
    serifid: "Rating 4"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3-5",
    serifid: "Rating 3,5"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3",
    serifid: "Rating 3"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2-5",
    serifid: "Rating 2,5"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2",
    serifid: "Rating 2"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1-5",
    serifid: "Rating 1,5"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1",
    serifid: "Rating 1"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "boxes-stacked"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "chat-left-text"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconR-list-ordered",
    x: 0,
    y: 0,
    width: 24,
    height: 23.983,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "ph-list-numbers"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.552,12.17c-0,0.393 -0.319,0.713 -0.713,0.713l-9.977,-0c-0.393,-0 -0.712,-0.32 -0.712,-0.713c-0,-0.394 0.319,-0.713 0.712,-0.713l9.977,0c0.394,0 0.713,0.319 0.713,0.713Zm-10.69,-4.989l9.977,0c0.394,0 0.713,-0.319 0.713,-0.712c-0,-0.394 -0.319,-0.713 -0.713,-0.713l-9.977,0c-0.393,0 -0.712,0.319 -0.712,0.713c-0,0.393 0.319,0.712 0.712,0.712Zm9.977,9.977l-9.977,0c-0.393,0 -0.712,0.32 -0.712,0.713c-0,0.394 0.319,0.713 0.712,0.713l9.977,-0c0.394,-0 0.713,-0.319 0.713,-0.713c-0,-0.393 -0.319,-0.713 -0.713,-0.713Zm-15.359,-10.408l0.394,-0.197l-0,3.835c-0,0.393 0.319,0.712 0.712,0.712c0.394,0 0.713,-0.319 0.713,-0.712l0,-4.988c0,-0.394 -0.319,-0.713 -0.712,-0.713c-0.117,0 -0.226,0.028 -0.323,0.077l0.004,-0.002l-1.426,0.713c-0.235,0.119 -0.394,0.36 -0.394,0.638c0,0.393 0.319,0.712 0.713,0.712c0.116,0 0.226,-0.028 0.323,-0.077l-0.004,0.002l-0,-0Zm2.553,9.189c0.21,-0.308 0.335,-0.688 0.335,-1.096c0,-1.083 -0.877,-1.96 -1.96,-1.96c-0.807,-0 -1.5,0.487 -1.8,1.184l-0.005,0.012c-0.036,0.082 -0.056,0.178 -0.056,0.278c-0,0.394 0.319,0.713 0.712,0.713c0.293,-0 0.545,-0.178 0.655,-0.431l0.002,-0.004c0.083,-0.194 0.272,-0.327 0.492,-0.327c0.295,-0 0.535,0.239 0.535,0.535c-0,0.106 -0.031,0.205 -0.085,0.288l0.001,-0.002l-2.268,3.027c-0.089,0.118 -0.143,0.267 -0.143,0.428c0,0.393 0.32,0.712 0.713,0.712l2.494,0c0.394,0 0.713,-0.319 0.713,-0.712c0,-0.394 -0.319,-0.713 -0.713,-0.713l-1.069,0l1.427,-1.904c0.007,-0.009 0.013,-0.019 0.02,-0.028l-0,-0Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRListOrdered);
export default __webpack_public_path__ + "static/media/iconR-list-ordered.26fc843582dc27d5bc64ffa7685defba.svg";
export { ForwardRef as ReactComponent };